<template>
  <section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55"/>-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
            >
              <section slot-scope="scope">

                <section>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
<!--          &lt;!&ndash; 操作按钮 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="control"-->
<!--              label="操作"-->
<!--              width="120"-->
<!--              fixed="left"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <TableBtn-->
<!--                  :tableData="scope.row"-->
<!--                  :isShowDropdown="true"-->
<!--                  :isCenter="false"-->
<!--                  :btnList="[-->
<!--                  {-->
<!--                    permpisions: '',-->
<!--                    showCondition: scope.row.dispatchOrderStatus===1,-->
<!--                    name: '查询订单',-->
<!--                    event: () => toQueryOrder(scope.row),-->
<!--                  },-->
<!--                   {-->
<!--                    permpisions: '',-->
<!--                    showCondition: scope.row.dispatchOrderStatus===2,-->
<!--                    // showCondition:true,-->
<!--                    name: '派车',-->
<!--                    event: () => toSendCar('',scope.row),-->
<!--                  },-->
<!--                   {-->
<!--                    permpisions: '',-->
<!--                    showCondition: scope.row.dispatchOrderStatus===2,-->
<!--                    name: '取消',-->
<!--                    event: () => toCancel('',scope.row),-->
<!--                  },-->
<!--                ]"-->
<!--              />-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {getSourceDriverBySourceId} from 'api/operate';
import TableBtn from 'components/tableBtn/tableBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    // TableBtn, // 操作按钮
  },
  data () {
    return {
      searchBoxData: {
        sourceOfGoodsId: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'linkman', label: '司机姓名'},
          {prop: 'mobilePhone', label: '司机手机'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getSourceDriverBySourceId,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
